import React, {PureComponent} from 'react';
import PropTypes from 'prop-types';
import {Col, FormGroup, FormText, Label} from "reactstrap";
import {FormattedMessage} from "react-intl";
import Select from "react-select";

class MultiOpen extends PureComponent {

  componentDidMount() {
    const {questionFrom} = this.props;
    if(!questionFrom.fetchType){
      this.props.onChange({fetchType: this.props.configQuestionFrom.fetchTypes[0]});
    }
  }

  render() {
    const {errors, question, questionFrom, configQuestionFrom} = this.props;

    return (
      <React.Fragment>
        <FormGroup row>
          <Label lg={3} className="text-right"><FormattedMessage id="pipingForm.questionFrom.label.fetchType" /></Label>
          <Col lg={9}>
            <Select
              placeholder="Wybierz..."
              value={questionFrom.fetchType ? {value: questionFrom.fetchType, label: <FormattedMessage id={'pipingForm.questionFrom.multiOpen.fetchType.' + questionFrom.fetchType}>{(msg) => msg}</FormattedMessage>} : null}
              onChange={(e) => this.props.onChange({fetchType: e.value})}
              options={configQuestionFrom.fetchTypes.map(type => {
                return {
                  value: type,
                  label: <FormattedMessage id={'pipingForm.questionFrom.multiOpen.fetchType.' + type}>{(msg) => msg}</FormattedMessage>,
                }
              })}
            />
            <FormText color="danger">{_.has(errors, 'questionFrom.fetchType') ? errors.questionFrom.fetchType.join('; ') : false}</FormText>
          </Col>
        </FormGroup>
        <FormGroup row>
          <Label lg={3} className="text-right"><FormattedMessage id="pipingForm.questionFrom.multiOpen.label.places" /></Label>
          <Col lg={9}>
            <Select
              placeholder="Dowolne miejsce lub wybierz z listy..."
              isMulti={true}
              value={questionFrom.places ? questionFrom.places.map(answer => {
                return {
                  value: answer,
                  label: answer,
                }
              }) : []}
              onChange={(e) => this.props.onChange({places: e.map(v => v.value)})}
              options={_.range(1, question.answersCount+1).map(num => {
                return {
                  value: num,
                  label: num
                }
              })}
            />
            <FormText color="danger">{_.has(errors, 'questionFrom.places') ? errors.questionFrom.places.join('; ') : false}</FormText>
          </Col>
        </FormGroup>
      </React.Fragment>
    );
  }
}

MultiOpen.propTypes = {
  configQuestionFrom: PropTypes.shape({
    fetchTypes: PropTypes.array.isRequired,
  }).isRequired,
  question: PropTypes.shape({
    type: PropTypes.string.isRequired,
    answersCount: PropTypes.number.isRequired,
  }).isRequired,
  questionFrom: PropTypes.shape({
    fetchType: PropTypes.string.isRequired,
    places: PropTypes.array.isRequired,
  }).isRequired,
  onChange: PropTypes.func.isRequired,
};

export default MultiOpen;